/* ------------------------------------------------------------
 * Maison Montrose — comportements mobiles
 *
 * Une seule responsabilité : ranger la barre de navigation basse quand la
 * barre d'achat collante de la fiche produit sort (deux bandeaux empilés
 * mangeraient l'écran), et la ramener dès qu'elle se replie.
 *
 * Tout est inopérant au-delà de 749 px : la barre n'y existe pas. Aucune
 * écriture de style en dur — la mise en forme vit dans assets/mon-mobile.css.
 * ------------------------------------------------------------ */

(function () {
  'use strict';

  var phone = window.matchMedia('(max-width: 749px)');

  /* ---------- 1. Barre basse vs barre d'achat collante ---------- */

  (function navVsSticky() {
    var nav = document.querySelector('[data-mon-nav-mobile]');
    if (!nav) return;

    var sticky = document.querySelector('[data-mmp-sticky]');

    function sync() {
      var hide = phone.matches && sticky && sticky.classList.contains('is-visible');
      nav.classList.toggle('is-hidden', Boolean(hide));
    }

    if (sticky && 'MutationObserver' in window) {
      new MutationObserver(sync).observe(sticky, { attributes: true, attributeFilter: ['class'] });
    }

    listen(phone, sync);
    sync();
  })();

  /* ---------- utilitaires ---------- */

  function listen(query, handler) {
    if (typeof query.addEventListener === 'function') {
      query.addEventListener('change', handler);
    } else if (typeof query.addListener === 'function') {
      query.addListener(handler);
    }
  }
})();
